import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { McpSettingsPage } from './McpSettingsPage'

export const routes: RouteObject[] = [{ path: '/settings/mcp', element: <McpSettingsPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/mcp', label: 'MCP', icon: 'key', mobile: null, order: 40, parent: '/settings' },
]
